$(window).on("load", function() {

    $('.ask-devis-product').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var btnClicked = $(this);

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                'action': 'get_devis_form_product_popup',
            }
        }).done(function(response) {
            let modal = createModal('Demande de Devis', response);
            $('body').append(modal);

            let btn = document.createElement('button');
            btn.classList.add('d-none');
            btn.setAttribute('type', 'button');
            btn.setAttribute('data-bs-toggle', 'modal');
            btn.setAttribute('data-bs-target', '#askDevisModal');
            btn.id = 'askDevisModalBtn';
            $('body').append(btn);

            $('#askDevisModalBtn').trigger('click');

            const productInput = document.getElementById('product_name');
            productInput.value = $(btnClicked).data('product');
            productInput.setAttribute('readonly', '');

            const categoryInput = document.getElementById('category_name');
            categoryInput.value = $(btnClicked).data('category');
            categoryInput.setAttribute('readonly', '');
            
			const forms = document.querySelectorAll('.wpcf7 > form');
            forms.forEach(form => wpcf7.init(form));
        });
    });


    $('.ask-devis-default').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                'action': 'get_devis_form_popup',
            }
        }).done(function(response) {
            let modal = createModal('Demande de Devis', response);
            $('body').append(modal);

            let btn = document.createElement('button');
            btn.classList.add('d-none');
            btn.setAttribute('type', 'button');
            btn.setAttribute('data-bs-toggle', 'modal');
            btn.setAttribute('data-bs-target', '#askDevisModal');
            btn.id = 'askDevisModalBtn';
            $('body').append(btn);

            $('#askDevisModalBtn').trigger('click');
            
			const forms = document.querySelectorAll('.wpcf7 > form');
            forms.forEach(form => wpcf7.init(form));
        });
    });

    $('#destockage-popup').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                'action': 'get_destockage_form_popup',
            }
        }).done(function(response) {
            let modal = createModal('Destockage - Prise de contact', response);
            $('body').append(modal);

            let btn = document.createElement('button');
            btn.classList.add('d-none');
            btn.setAttribute('type', 'button');
            btn.setAttribute('data-bs-toggle', 'modal');
            btn.setAttribute('data-bs-target', '#askDevisModal');
            btn.id = 'askDevisModalBtn';
            $('body').append(btn);

            $('#askDevisModalBtn').trigger('click');

            const productInput = document.getElementById('product_name');
            productInput.value = $('.product_title')[0].innerHTML;
            productInput.setAttribute('readonly', '');
            
			const forms = document.querySelectorAll('.wpcf7 > form');
            forms.forEach(form => wpcf7.init(form));
        });
    });


    $(document).on('hidden.bs.modal', '#askDevisModal', function(e) {
        let btn = document.getElementById('askDevisModalBtn');
        btn.remove();

        let modal = document.getElementById('askDevisModal');
        modal.remove();
    });


    $(document).on('wpcf7mailsent', '.wpcf7', function(e) {
		var detail = e.detail;
		var contactId = detail.contactFormId;

		if(contactId == '454') {
            const rows = document.querySelectorAll('.modal .wpcf7 .row');
            rows.forEach(row => row.remove());
		}
	});


    function createModal(title, content) {
        let modal = document.createElement('div');
        modal.classList.add('modal', 'fade');
        modal.setAttribute('aria-hidden', 'true');
        modal.id = 'askDevisModal';

        let modal_dialog = document.createElement('div');
        modal_dialog.classList.add('modal-dialog', 'modal-dialog-centered', 'modal-lg');

        let modal_content = document.createElement('div');
        modal_content.classList.add('modal-content');

        let modal_header = document.createElement('div');
        modal_header.classList.add('modal-header');

        let modal_header_title = document.createElement('h5');
        modal_header_title.classList.add('modal-title');
        modal_header_title.append(title);

        let modal_header_close = document.createElement('button');
        modal_header_close.classList.add('btn-close');
        modal_header_close.setAttribute('type', 'button');
        modal_header_close.setAttribute('data-bs-dismiss', 'modal');
        modal_header_close.setAttribute('aria-label', 'Close');

        let modal_body = document.createElement('div');
        modal_body.classList.add('modal-body');
        modal_body.innerHTML = content;

        modal_header.append(modal_header_title);
        modal_header.append(modal_header_close);

        modal_content.append(modal_header);
        modal_content.append(modal_body);

        modal_dialog.append(modal_content);

        modal.append(modal_dialog);

        return modal;
    }
});